import stopsReducer from './stopsReducer';

export default stopsReducer;
